<template>
  <div class="dlrVRBottomMenu-pop">
    <div class="dlrVRBottomMenu-pop-bg">
      <a @click="hide" class="dlrVRBottomMenu-pop-close"></a>
      <div v-if="appealList.length > 0">
        <div class="dlrVRBottomMenu-pop-title">
          <p>客户带看诉求</p>
        </div>
        <div class="intentionPop-tags">
          <ul>
            <li v-for="item in appealList" :key="item.code">
              <p>
                <span>{{ item.desc }}</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="jxsShow">
        <div class="dlrVRBottomMenu-pop-title mt30">
          <p>客户参考意向</p>
        </div>
        <div class="intentionPop-refer">
          <ul>
            <li>
              <div class="intentionPop-refer-tag">
                <user-portrains :value="jxsBuycarIntention"></user-portrains>
              </div>
              <div class="intentionPop-refer-text">
                <p>购车意向</p>
              </div>
            </li>
            <li>
              <div class="intentionPop-refer-tag">
                <user-portrains :value="jxsHasCar"></user-portrains>
              </div>
              <div class="intentionPop-refer-text">
                <p>有车概率</p>
              </div>
            </li>
            <li>
              <div class="intentionPop-refer-tag">
                <user-portrains :value="jxsReplaceDemand"></user-portrains>
              </div>
              <div class="intentionPop-refer-text">
                <p>置换意向</p>
              </div>
            </li>
            <li>
              <div class="intentionPop-refer-tag">
                <h6>
                  <span>{{ jxsBuycarPurpow }}</span>
                </h6>
              </div>
              <div class="intentionPop-refer-text">
                <p>购车预算</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="dlrVRBottomMenu-pop-mask"></div>
  </div>
</template>
<script>
import UserPortrains from './UserPortrains.vue';
export default {
  components: {
    UserPortrains,
  },
  props: {
    jxsBuycarPurpow: {
      type: String,
      default: ''
    },
    jxsReplaceDemand: {
      type: String,
      default: ''
    },
    jxsHasCar: {
      type: String,
      default: ''
    },
    jxsBuycarIntention: {
      type: String,
      default: ''
    },
    appealList: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },
  computed: {
    jxsShow () {
      return !!this.jxsBuycarIntention && !!this.jxsHasCar && !!this.jxsReplaceDemand && !!this.jxsBuycarPurpow;
    }
  },
  methods: {
    hide () {
      this.$emit('hide');
    }
  },
};
</script>
